module.exports = __webpack_public_path__ + "static/media/bannerIcon.e606162f.svg";